import { PropTypes } from 'prop-types';
import React, { forwardRef } from 'react';

import { COLORS } from '../../../constants/colors';
import { toCamelCase } from '../../../utils';
import PodcastHeader from '../../Podcast/PodcastHeader';
import ArticleHeroImage from '../ArticleHeroImage';

const ArticlePodcastHeader = forwardRef(
  ({ header, heroImage, podcastTheme }, ref) => {
    const backgroundColor = COLORS[toCamelCase(header.backgroundColor)];
    const color = toCamelCase(header.textColor);
    return (
      <div ref={ref}>
        <div
          className={`article-podcast-header ${color} `}
          style={{ backgroundColor }}
        >
          <div className="article-podcast-header--container">
            {podcastTheme && <PodcastHeader podcastTheme={podcastTheme} />}
          </div>
        </div>
        {heroImage && (
          <ArticleHeroImage image={heroImage.image} title={heroImage.title} />
        )}
      </div>
    );
  },
);

ArticlePodcastHeader.propTypes = {
  header: PropTypes.object,
  heroImage: PropTypes.object,
  podcastTheme: PropTypes.string,
};

export default ArticlePodcastHeader;
